import { create } from 'zustand';
import type { LoginResponse } from '@shared/api';
import { LocalStorageUtils } from '@shared/utils';

interface UseAuthStoreV2 {
  data: LoginResponse | null;
  setAuth: (payload: LoginResponse) => void;
  clear: () => void;
}

export const useAuthStore = create<UseAuthStoreV2>((set) => ({
  data: LocalStorageUtils.getAuth(),

  setAuth: (data) => set(() => ({ data })),

  clear: () => set(() => ({ data: null })),
}));
